'use client'

import type { PropsWithChildren } from 'react'

const VaultConfigurationLayout = ({ children }: PropsWithChildren) => {
  return (
    <div className="gap-sm flex flex-col">
      <span className="text-foreground text-sm">Vault Configuration</span>
      {children}
    </div>
  )
}

export default VaultConfigurationLayout
